import React from 'react'
import clsx from 'clsx'
import NoteBuilder from '../../NoteBuilder/NoteBuilder'
import DataTable from '../../DataTable/DataTable'

class GroupContractBuilderNotes extends React.Component {
  constructor(props) {
    super(props)

  }
  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'notes',
      'tab-pane': true
    })
    return(
      <div className={tabClasses} id='notes'>
        {
          this.props.new_record
            ? <NoteBuilder 
                note={this.props.note_obj}
                new_record={true}
                onChangeNote={this.props.onChangeNote}
                onChangeImageGroup={this.props.onChangeImageGroup}
                onChangeFlagged={this.props.onChangeFlagged}
                buttons={this.props.buttons} />
            : <DataTable
                endpoint={this.props.group_contract_notes_path}
                updateNoteCount={this.props.updateNoteCount}
                date_format={this.props.date_format}
                time_format={this.props.time_format}
                read_only={this.props.read_only} />
        }
      </div>
    )
  }
}
export default GroupContractBuilderNotes
